<template>
  <div id="owner_businesses_lis">
    <CardedTable :items="items" :headers="headers">
      <template v-slot:[`item.is_main_branch`]="{ item }">
        <!-- { id: 0, name: "No Branch" },
        { id: 1, name: "Main Branch" },
        { id: 2, name: "Is Sub Branch" }, -->
        {{parseInt(item.is_main_branch) == 0 ? "No Branch" : (parseInt(item.is_main_branch) == 1? "Main Branch": "Sub Branch")}}
      </template>
      <template v-slot:[`item.is_branch_of_id`]="{ item }">
        {{parseInt(item.is_branch_of_id) == -1 ? "" : (parseInt(item.is_main_branch) == 0? "": indexed_businesses[item.id].name)}}
      </template>
      <template v-slot:[`item.is_verified`]="{ item }">
        <span class="red--text" v-if="parseInt(item.is_verified) == 0"><b>Pending</b></span>
        <span class="blue--text" v-if="parseInt(item.is_verified) == 1"><b>Processing</b></span>
        <span class="green--text" v-if="parseInt(item.is_verified) == 2"><b>Verified</b></span>
        
      </template>

      
      <template v-slot:[`item.actions`]="{ item }">
        <v-btn @click="on_view_item(item)" x-small rounded text color="success">
          <v-icon>mdi-eye</v-icon>
        </v-btn>
      </template>
    </CardedTable>
  </div>
</template>

<script>
import CardedTable from "../../../components/CardedTable";
import ServerClient from "../../../lib/ServerClient";
export default {
  name: "OwnerBusinessesList",
  components: {
    CardedTable,
  },
  props: {
    is_loading: {
      type: Boolean,
      default: false,
    },
    user: {
      type: Object,
      default: () => {
          return ServerClient.Login.get_logged_in_user();
      },
    },
  },
  data: () => {
    return {
        _user: null,
      items: [],
      headers: [
        {
          text: "Name",
          align: "start",
          sortable: true,
          value: "name",
          filterable: true,
        },
        {
          text: "District",
          align: "start",
          sortable: false,
          value: "district.name",
          filterable: true,
        },
        {
          text: "Is Branch",
          align: "start",
          sortable: false,
          value: "is_main_branch",
          filterable: false,
        },
        {
          text: "Branch Of",
          align: "start",
          sortable: false,
          value: "is_branch_of_id",
          filterable: false,
        },
        {
          text: "Verification",
          align: "start",
          sortable: false,
          value: "is_verified",
          filterable: false,
        },
        { text: "", value: "actions", sortable: false, align: "end", },
      ],
      indexed_businesses: {}
    };
  },
  methods: {
    load_items() {
      this.$emit("on-show-loader");
      ServerClient.Businesses.get_my_buinesses(
        {
            user_id: this._user.id
        },
        (res) => {
          this.$emit("on-hide-loader");
          var temp = {};
          for (var index = 0; index < res.length; index++) {
            var busin = res[index];
            temp[busin.id] = busin;
          }
          this.indexed_businesses = temp;
          this.items = res;
        },
        (errors) => {
          this.$emit("on-hide-loader");
          console.log("Errors while loading busineeses on owners businessese list", errors);
        }
      );
    },
    on_view_item(item) {
      this.$router.push("/owner/businesses/list/view/" + item.id);
    },
  },
  mounted() {
      this._user = ServerClient.Login.get_logged_in_user();
    this.$emit("set-page-attributes", {
      title: "List Of My Businesses",
      crumps: [
        {
          text: "Owner",
          disabled: false,
          href: "/owner",
        },
        {
          text: "Buinesses",
          disabled: false,
          href: "/owner/businesses",
        },
        {
          text: "List",
          disabled: true,
          href: "/owner/businesses/list",
        },
      ],
    });
    this.load_items();

    var options = {
      offset: 50,
      duration: 1000,
      easing: "easeInOutCubic",
    };
    this.$vuetify.goTo("#owner_businesses_lis", options);
  },
};
</script>